import { LoginLayout } from '@layouts/login';

export const SignIn = () => <LoginLayout />;
